import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Button, CircularProgress, Container, Typography } from '@mui/material';
// import { wizardApi } from '../services/wizardApi';
import RuntimeWizard from '../RuntimeWizard';
import wizardApi from '../../../../service';
// import { wizardApi } from '../wizardApi';

const RuntimeWizardLoader = () => {
    const { wizardId } = useParams();
    const [wizardSchema, setWizardSchema] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadWizard = async () => {
            try {
                setLoading(true);
                if (wizardId) {
                    const wizard = await wizardApi.getWizard(wizardId);
                    if (wizard?.jsonSchema) {
                        setWizardSchema(wizard.jsonSchema);
                    } else {
                        throw new Error('Wizard not found or has no schema');
                    }
                } else {
                    const previewData = localStorage.getItem('previewWizard');
                    if (previewData) {
                        const parsed = JSON.parse(previewData);
                        setWizardSchema(parsed.schema);
                    } else {
                        throw new Error('No wizard data found');
                    }
                }
                setError(null);
            } catch (err) {
                console.error('Error loading wizard:', err);
                setError(err.message);
                setWizardSchema(null);
            } finally {
                setLoading(false);
            }
        };

        loadWizard();
    }, [wizardId]);

    if (loading) {
        return (
            <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Loading wizard...</Typography>
            </Container>
        );
    }

    if (error || !wizardSchema) {
        return (
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error || 'Failed to load wizard'}
                </Alert>
                <Button
                    variant="outlined"
                    onClick={() => window.location.href = '/'}
                >
                    Go to Form Wizard
                </Button>
            </Container>
        );
    }

    return <RuntimeWizard wizardSchema={wizardSchema} />;
};

export default RuntimeWizardLoader;